import Vue from 'vue'
import Router from 'vue-router'

import $ from 'jquery'
import '../../node_modules/bootstrap/dist/css/bootstrap.min.css';
import '../../node_modules/bootstrap/dist/js/bootstrap.min.js';
import Login from '@/components/login'
import Register from '@/components/register'
import Forget from '@/components/forget'
import Index from '@/components/index'
import JoinNotice from '@/components/joinNotice'
import Apply from '@/components/apply'
import ApplyStep2 from '@/components/applyStep2'
import ApplyStep3 from '@/components/applyStep3'
import SubmitCheck from '@/components/submitCheck'
import DataTypein from '@/components/dataTypein'
import Management from '@/components/management'
import ApplyForm from '@/components/applyForm'
import Detail from '@/components/detail'
import Edit from '@/components/edit'
import Complete from '@/components/complete'
import Edit2 from '@/components/edit2'
import TableDetail from '@/components/tableDetail'
Vue.use(Router)

export default new Router({
  routes: [{
    path: '/login', // √
    name: '登录',
    component: Login
  }, {
    path: '/register', // √
    name: '注册',
    component: Register
  }, {
    path: '/forget', // √
    name: '找回密码',
    component: Forget
  }, {
    path: '/', // √
    name: '首页',
    component: Index
  }, {
    path: '/joinNotice', // √
    name: '入会须知',
    component: JoinNotice
  }, {
    path: '/apply', // √
    name: '会员登记申请',
    component: Apply
  }, {
    path: '/applyStep2', // √
    name: '会员登记申请第二步',
    component: ApplyStep2
  }, {
    path: '/applyStep3', // √
    name: '会员登记申请第三步',
    component: ApplyStep3
  }, {
    path: '/submit', // √
    name: '提交审核',
    component: SubmitCheck
  }, {
    path: '/dataTypein', // √
    name: '资料录入',
    component: DataTypein
  }, {
    path: '/management', // √
    name: '账号管理',
    component: Management
  }, {
    path: '/applyForm', // √
    name: '资料录入',
    component: ApplyForm
  }, {
    path: '/detail', // √
    name: '详情',
    component: Detail
  }, {
    path: '/table', // √
    name: '详情',
    component: TableDetail
  }, {
    path: '/edit', // √
    name: '修改',
    component: Edit
  }, {
    path: '/complete', // √
    name: '完善资料',
    component: Complete
  }, {
    path: '/edit2', // √
    name: '修改',
    component: Edit2
  },]
})



// WEBPACK FOOTER //
// ./src/router/index.js